import React from 'react';
import Container from 'react-bootstrap/esm/Container';

import { RegionTable } from '../Component/RegionsAndAreasComponents/RegionTable';

export const RegionsAndAreas = () => {
  return (
    <Container className="startpage">
      <RegionTable />
    </Container>
  );
};
